<template>
    <div class="main">
      <epp-banner :type="1"></epp-banner>
      <div class="menu-list">
          <div class="menu-item" v-for="(item,index) in menuList" :key="index">
              <div v-if="item.jumpApplet">
                  <wx-open-launch-weapp
                      style="height: 100%;width: 100%;"
                      id="launch-btn"
                      appid="wx78248ab2e6a420ec"
                      username="gh_464305d43974"
                      path="pages/index/index"
                      >
                      <script type="text/wxtag-template">
                          <style>
                              .menu-item-img {
                                  position: relative;
                                  display: flex;
                                  justify-content: center;
                                  margin-top: .8rem;
                              }
                              .menu-item-img .menu-img {
                                  width: 2.6rem;
                                  height: 2.4333rem;
                              }
                              .menu-item-img .menu-img-bgc {
                                  position: absolute;
                                  bottom: 0;
                                  width: 4.3667rem;
                                  height: 1.3667rem;
                              }
                              .f-s-12 {
                                  margin-top: .6rem;
                                  font-size: 12px;
                                  text-align: center;
                              }
                          </style>
                          <div class="menu-item-img">
                              <img fit="fill" class="menu-img" src="{{ cdnUrl + item.img }}" />
                              <img fit="fill" class="menu-img-bgc" src="{{ cdnUrl + 'FkilH56BxBbo7on8WBbu1eXwwHip' }}" />
                          </div>
                          <p class="f-s-12">{{ item.name }}</p>
                      </script>
                  </wx-open-launch-weapp>
              </div>
              <div v-else  @click="handleUrl(item.url)">
                  <div class="menu-item-img">
                      <van-image fit="fill" class="menu-img" :src="cdnUrl + item.img" />
                      <van-image fit="fill" class="menu-img-bgc" :src="cdnUrl + 'FkilH56BxBbo7on8WBbu1eXwwHip'" />
                      <span v-if="item.tip" class="hot-tip">HOT</span>
                  </div>
                  <p class="f-s-12">{{ item.name }}</p>
              </div>
          </div>
      </div>
      <!-- 菜单 -->
      <div class="menu-bot" @click="handleUrl(hostUrl + '/eppendorf_single/index.html#/pipetteHome')">
          <p class="menu-bot-tip">移液加速站</p>
          <van-image fit="fill" class="bot-img" :src="cdnUrl + 'FmepX3rNE6lbwcIp7qwp7Rq-C1HE'" />
      </div>
      <div class="menu-bot" @click="handleUrl(hostUrl + '/eppendorf_single/index.html#/centrifugeHome')">
          <van-image fit="fill" class="bot-img-school" :src="cdnUrl + 'Fi8yCbmKKH0YgRnNCnyatXIQl0e1'" />
          <p class="menu-bot-tip">离心直通车</p>
      </div>
      <van-popup  v-model="actShow">
          <img class="act_img" :src="cdnUrl + 'FoIDRy-gpeXmhpHqmDxqmxqAI-Gc'" alt="">
      </van-popup>
    </div>
  </template>
  
  
  <!-- 公众号 JSSDK -->
  <script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
  <script>
  import { getBannerList } from '@/api/label'
  import eppBanner from '@/components/eppBanner'
  import { wxShare, wxSdkConfig } from '@/libs/wxjssdk'
  import { centrifugeRecord } from '@/libs/common'
  var changUrl = window.location.origin
  export default {
      components: {
          eppBanner
      },
      data () {
          return {
              cdnUrl: this.$config.baseUrl.cdnUrl,
              logo: 'Fr23uoHKjiB7Qkl23ZZ7MyJ1imlp',
              current: 0, // 当前轮播下标
              img_url: [],
              actShow: false,
              menuList: [
                  { img: 'FsrKxMxWRNuPLGY1e8kz7zJRa4h_',name: '产品中心', tip: 'HOT',url: changUrl + '/eppendorf_single/index.html?from=singlemessage&isappinstalled=0#/productStore', jumpApplet: false },
                  { img: 'FnDYwU4n2T2rcV1i1c1w6_KEf-nt',name: '解决方案', tip: 'HOT',url: changUrl + '/eppendorf_single/index.html?from=singlemessage&isappinstalled=0#/solutionHome', jumpApplet: false },
                  { img: 'FpJfMPcNitf2Pdl8lG23YiTn_UlR',name: '关于我们', tip: '',url: changUrl + '/about.html?type=1', jumpApplet: false },
                  { img: 'Fl5KQtpyfHWNpLCoIi52mAoX0lRI',name: '视频号', tip: '',url: changUrl + 'eppendorf_single/index.html#/sceneActivity', jumpApplet: false },
                  { img: 'FvxxqP3yu97IsapGgQW0tzldnoK0',name: '艾博士空间站', tip: '',url: 'https://tools.eppendorf.cn/mobile/home', jumpApplet: false },
                  { img: 'FhcCR4koJn1h5krdN_-3K11pxVly',name: '服务与支持', tip: '',url: 'http://eppendorf.adinnet.cn/', jumpApplet: true },
              ],
              hostUrl: window.location.origin
          }
      },
      created() {
           let para = {
              type: 36, // 微站首页记录
              type_id: 0,
              uid: this.$store.state.user.id || 0,
              action: 1
          }
          centrifugeRecord(para) // 人数，次数记录
          // 获取微信签名
          wxSdkConfig();
      },
      mounted() {
          this.sharePage()
      },
      methods: {
          handleUrl(url) {
              if (url.indexOf('sceneActivity') != -1) {
                  this.actShow = true
                  return
              }
              if(url) {
                  window.location.href = url
              }else {
                  this.$toast('敬请期待')
              }
          },
          sharePage () {
            const params = {
              title: '首页', // 分享标题
              desc: 'Eppendorf 实验室官方微站', // 分享描述
              link: window.location.href,
              imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
          }
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .main {
      padding-bottom: rem(29);
  }
  .act_img {
      width: 100%;
      height: auto;
  }
  .f-s-12 {
      margin-top: rem(9);
      font-size: 12px;
      text-align: center;
  }
  
  .menu-list {
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
      margin-top: rem(10);
      padding: 0 rem(35);
      .menu-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: rem(72);
          margin-top: rem(25);
          margin-right: rem(42);
          .hot-tip {
              position: absolute;
              top: rem(-20);
              right: rem(-8);
              padding: 3px 4px;
              font-size: 8px;
              color: #fff;
              background-color: #F43338;
              border-radius: rem(5) 0 rem(5) 0;
          }
      }
      .menu-item:nth-child(3n) {
          margin-right: 0;
      }
      .menu-item-img {
          position: relative;
          display: flex;
          justify-content: center;
          .menu-img {
              width: rem(39);
              height: rem(37);
          }
          .menu-img-bgc {
              position: absolute;
              // left: 0;
              bottom: 0;
              width: rem(65);
              height: rem(20);
          }
      }
     
  }
  .menu-bot {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: rem(347);
      height: rem(136);
      margin: 0 auto;
      margin-top: rem(38);
      background-color: #eff9fb;
      border-radius: 13px;
      .menu-bot-tip {
          position: relative;
          font-size: 19px;
          padding: 0 rem(8);
          font-weight: bold;
          color: #000;
      }
      .menu-bot-tip::after {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 2px;
          height: 7px;
          content: " ";
          z-index: 1;
          background: #91d3e4;
          opacity: 0.4;
          border-radius: 4px;
      }
      .bot-img {
          width: rem(95);
          height: rem(151);
          margin-top: rem(-25);
      }
      .bot-img-school {
          width: rem(170);
          height: rem(137);
          margin-top: rem(-25);
      }
  }
  </style>